import { CircleModel } from 'api/dto/Circle.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'circles';

export namespace CirclesState {
  export type Domain = {
    list: Resource<CircleModel[]>;
  };

  export const INITIAL_DOMAIN: Domain = {
    list: Resource.createPendingResource(),
  };
}

export type CirclesState = {
  circles?: CirclesState.Domain;
};
